var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab-switcher"},[_c('li',{class:{'is-active': _vm.activeTab === 'activities'},attrs:{"data-testid":"activitiesTab"}},[_vm._t("activities")],2),_vm._v(" "),_c('li',{class:{'is-active': _vm.activeTab === 'locations'},attrs:{"data-testid":"locationsTab"}},[_vm._t("locations")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-461e1a92","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabSwitcher.vue
// module id = 689
// module chunks = 0